/**
 * It takes a string and returns a string with all instances of &quot replaced with a double quote
 * @param {string} value - string - the value to be replaced
 */
export const withoutQuot = (value: string): string => value?.replace(`&quot;`, `"`)
